export enum Lookup {
  id = 'id',
  value = 'value'
}
export interface ILookup {
  [Lookup.id]: string;
  [Lookup.value]: string;
}
